import React from 'react';

import Accordion from 'components/Accordion';
import { Comparison } from 'helper/products/meteorology';
import Preference from './Preference';

interface PreferencesAccordionProps {
  preferenceList: Comparison[],
  deleteTrigger: ({ id }: { id: number }) => void,
  deleteLoading: boolean,
}

export default function PreferencesAccordion({
  preferenceList,
  deleteTrigger,
  deleteLoading,
}: PreferencesAccordionProps) {
  return (
    <Accordion.Item eventKey="1">
      <Accordion.Header>Preferências Salvas</Accordion.Header>
      <Accordion.Body>
        { preferenceList.map((preference) => (
          <Preference
            key={preference.id}
            preference={preference}
            onDelete={deleteTrigger}
            deleteLoading={deleteLoading}
          />
        )) }
      </Accordion.Body>
    </Accordion.Item>
  );
}
